import React, { useState, useEffect } from 'react'
import { Grid, Typography, TextField, Box } from '@material-ui/core'

function FrequencyRangeFilterModal({ value = [0, 1], onChange, onClose, title = 'Frequency', min = 0, max = 1 }) {
  const [minValue, setMinValue] = useState(value[0] || min)
  const [maxValue, setMaxValue] = useState(value[1] || max)
  const [minInput, setMinInput] = useState((value[0] || min).toString())
  const [maxInput, setMaxInput] = useState((value[1] || max).toString())

  // Update local state when prop changes (only on initial load)
  useEffect(() => {
    setMinValue(value[0] || min)
    setMaxValue(value[1] || max)
    setMinInput((value[0] || min).toString())
    setMaxInput((value[1] || max).toString())
  }, []) // Empty dependency array - only run once

  const handleMinChange = (event) => {
    const inputValue = event.target.value
    setMinInput(inputValue)

    if (inputValue === '') {
      // Allow empty input for better UX
      return
    }

    const newValue = parseFloat(inputValue)
    if (!isNaN(newValue)) {
      setMinValue(newValue)
      // Update parent immediately
      onChange([newValue, maxValue])
    }
  }

  const handleMaxChange = (event) => {
    const inputValue = event.target.value
    setMaxInput(inputValue)

    if (inputValue === '') {
      // Allow empty input for better UX
      return
    }

    const newValue = parseFloat(inputValue)
    if (!isNaN(newValue)) {
      setMaxValue(newValue)
      // Update parent immediately
      onChange([minValue, newValue])
    }
  }

  const handleMinBlur = () => {
    if (minInput === '') {
      setMinInput(minValue.toString())
    }
  }

  const handleMaxBlur = () => {
    if (maxInput === '') {
      setMaxInput(maxValue.toString())
    }
  }

  const isValid = minValue <= maxValue && minValue >= min && maxValue <= max

  return (
    <Grid container spacing={2} style={{ marginTop: '10px' }}>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Minimum"
          type="number"
          value={minInput}
          onChange={handleMinChange}
          onBlur={handleMinBlur}
          inputProps={{
            min: min,
            max: max,
            step: 0.001,
          }}
          variant="outlined"
          size="small"
          error={!isValid}
          helperText={!isValid ? 'Invalid range' : `Min: ${min}`}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Maximum"
          type="number"
          value={maxInput}
          onChange={handleMaxChange}
          onBlur={handleMaxBlur}
          inputProps={{
            min: min,
            max: max,
            step: 0.001,
          }}
          variant="outlined"
          size="small"
          error={!isValid}
          helperText={!isValid ? 'Invalid range' : `Max: ${max}`}
        />
      </Grid>
      {!isValid && (
        <Grid item xs={12}>
          <Typography variant="body2" color="error">
            Invalid range: Minimum must be less than or equal to maximum
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default FrequencyRangeFilterModal
